export default __webpack_public_path__ + "static/hidahidakaya-a942dc0b1d20f93ff6d5f4ef9165b60a.png";